/*
 * Golf24 - Kundennotiz und Personalisierung für SAP/BOB
 * Benötigt die Anpassung des cart-note-Elements in cart.js.
 */

(() => {
  if (window.golf24SapNoteInitialized) return;
  window.golf24SapNoteInitialized = true;

  const START = '= PERSONALISIERUNG START =';
  const END = '= PERSONALISIERUNG ENDE =';
  const root = window.Shopify?.routes?.root || '/';

  const cartUrl = root + 'cart.js';
  const updateUrl = root + 'cart/update.js';

  let processing = false;
  let saveTimer = null;
  let noteRevision = 0;
  let latestCustomerNote = null;
  let saveQueue = Promise.resolve();
  const pendingChanges = new Set();

  function clean(value) {
    return String(value ?? '')
      .replace(/[\r\n\t]+/g, ' ')
      .trim();
  }

  function removeGeneratedBlock(note) {
    const text = String(note || '');
    const start = text.indexOf(START);

    if (start === -1) return text.trim();

    const end = text.indexOf(END, start);

    if (end === -1) {
      throw new Error(
        'Unvollständiger Personalisierungsblock in der Bestellnotiz.'
      );
    }

    return (
      text.slice(0, start) +
      text.slice(end + END.length)
    ).trim();
  }

  function buildPersonalization(cart) {
    const entries = [];

    for (const item of cart.items) {
      const p = item.properties || {};
        const validateText = (value, maxLength) => {
        const text = clean(value);

        if (text.length > maxLength) {
            throw new Error(
            'Eine Personalisierungsangabe überschreitet ' +
            'die zulässige Zeichenlänge.'
            );
        }

        return text;
        };
      const taylormade = Boolean(
        clean(p['Beschriftung Zeile 1'])
      );
      const simple = Boolean(clean(p['Beschriftung']));

      if (!taylormade && !simple) continue;

      const lines = [
        'Artikel: ' + clean(item.product_title),
        'SKU: ' + clean(item.sku || 'Keine SKU'),
        'Menge: ' + item.quantity
      ];

      if (taylormade) {
        for (let i = 1; i <= 3; i++) {
                    const value = validateText(
            p['Beschriftung Zeile ' + i],
            17
            );

            if (value) {
            lines.push('Zeile ' + i + ': ' + value);
            }
        }

        lines.push(
          'Schriftfarbe: ' +
          clean(p['Schriftfarbe'] || 'Nicht angegeben')
        );

        lines.push(
          'Druckart: ' +
          clean(p['Druckart'] || 'Vertikaldruck')
        );
     }  else {
        lines.push(
            'Beschriftung: ' +
            validateText(p['Beschriftung'], 15)
        );
        }

      entries.push(lines.join('\n'));
    }

    if (!entries.length) return '';

    return [
      START,
      entries.join('\n\n--------------------\n\n'),
      END
    ].join('\n');
  }

  function getNoteFields() {
    return [
      document.getElementById('CartDrawer-Note'),
      document.getElementById('Cart-note')
    ].filter(Boolean);
  }

  function showCustomerNote() {
    for (const field of getNoteFields()) {
      if (document.activeElement === field) continue;

      try {
        const value = removeGeneratedBlock(field.value);

        if (latestCustomerNote !== null) {
          field.value = latestCustomerNote;
        } else if (field.value !== value) {
          field.value = value;
        }
      } catch (error) {
        console.error('Golf24 Notizanzeige:', error);
      }
    }
  }

  function getCurrentCustomerNote(cart) {
    if (latestCustomerNote !== null) {
      return latestCustomerNote;
    }

    const visible = getNoteFields().find(
      field => field.getClientRects().length > 0
    );

    if (visible) {
      return removeGeneratedBlock(visible.value);
    }

    return removeGeneratedBlock(cart.note || '');
  }

  async function readCart() {
    const response = await fetch(cartUrl, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Warenkorb konnte nicht geladen werden.');
    }

    return response.json();
  }

  async function waitForChanges() {
    const deadline = Date.now() + 10000;

    while (pendingChanges.size) {
      if (Date.now() > deadline) {
        throw new Error('Warenkorbänderung dauert zu lange.');
      }

      await Promise.allSettled([...pendingChanges]);
    }
  }

  async function saveNote() {
    await waitForChanges();

    const cart = await readCart();
    const customerNote = getCurrentCustomerNote(cart);
    const personalization = buildPersonalization(cart);

    const fullNote = [
      customerNote,
      personalization
    ].filter(Boolean).join('\n\n');

    if (fullNote === String(cart.note || '')) {
      return;
    }

    const response = await fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: fullNote })
    });

    if (!response.ok) {
      throw new Error('Bestellnotiz konnte nicht gespeichert werden.');
    }

    const updated = await response.json();

    if (String(updated.note || '') !== fullNote) {
      throw new Error('Bestellnotiz wurde nicht vollständig gespeichert.');
    }
  }

  // Alle Notiz-Schreibvorgänge nacheinander ausführen.
function queueSave() {
  const task = saveQueue
    .catch((error) => {
      console.warn(
        'Golf24: Vorheriger Speichervorgang fehlgeschlagen.',
        error
      );
    })
    .then(() => saveNote());

  saveQueue = task;
  return task;
}
  // Kundeneingaben mit kurzer Verzögerung speichern.
  document.addEventListener('golf24:customer-note-input', event => {
    latestCustomerNote = removeGeneratedBlock(
      event.detail.value
    );

    noteRevision++;
    const revision = noteRevision;

    clearTimeout(saveTimer);

    saveTimer = setTimeout(() => {
      if (revision !== noteRevision) return;

      queueSave().catch(error => {
        console.error('Golf24 Kundennotiz:', error);
      });
    }, 600);
  });

  // Änderungen an Warenkorbpositionen beobachten.
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const request = args[0];
    const requestUrl = String(
      typeof request === 'string'
        ? request
        : request?.url || ''
    );

    const method = String(
      args[1]?.method ||
      (typeof request === 'object' ? request?.method : '') ||
      'GET'
    ).toUpperCase();

    const cartMutation =
      method !== 'GET' &&
      /\/cart\/(change|add|clear)(\.js)?(?:\?|$)/.test(
        requestUrl
      );

    const result = originalFetch.apply(this, args);

    if (cartMutation) {
      pendingChanges.add(result);

      result.then(
        () => pendingChanges.delete(result),
        () => pendingChanges.delete(result)
      );
    }

    return result;
  };

async function checkout() {
  if (processing) return;

  processing = true;

  try {
    // Automatische Notizspeicherung stoppen.
    clearTimeout(saveTimer);

    // Frühere Speichervorgänge abschließen.
    // Ein früherer Fehler wird durch den
    // folgenden finalen Speicherversuch korrigiert.
    await saveQueue.catch((error) => {
      console.warn(
        'Golf24: Frühere Notizspeicherung fehlgeschlagen.',
        error
      );
    });

    // Laufende Warenkorbänderungen abwarten.
    await waitForChanges();

    // Aktuellen Warenkorb erneut einlesen und
    // Kundennotiz + Personalisierung speichern.
    await queueSave();

    // Nach der Speicherung nochmals kontrollieren.
    const cart = await readCart();

    const expectedNote = [
      getCurrentCustomerNote(cart),
      buildPersonalization(cart)
    ].filter(Boolean).join('\n\n');

    if (String(cart.note || '') !== expectedNote) {
      throw new Error(
        'Die Bestellnotiz stimmt nicht mit den ' +
        'aktuellen Personalisierungsangaben überein.'
      );
    }

    // Erst nach erfolgreicher Kontrolle weiter.
    window.location.assign(root + 'checkout');

  } catch (error) {
    processing = false;

    console.error('Golf24 Checkout:', error);

    alert(
      'Die Bestellangaben konnten nicht vollständig ' +
      'gespeichert werden.\n\n' +
      'Bitte versuche es erneut oder kontaktiere ' +
      'unseren Kundenservice.\n\n' +
      error.message
    );
  }
}

  // Checkout-Schaltflächen abfangen.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
      'button[name="checkout"], ' +
      'input[name="checkout"], ' +
      'a[href$="/checkout"]'
    );

    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    checkout();
  }, true);

  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    checkout();
  }, true);

  // Notizfelder nach Shopify-Neurendering bereinigen.
  let observerScheduled = false;

  const observer = new MutationObserver(() => {
    if (observerScheduled) return;

    observerScheduled = true;

    requestAnimationFrame(() => {
      observerScheduled = false;
      showCustomerNote();
    });
  });

  function initialize() {
    showCustomerNote();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();